import { EventMeta } from '../../../interfaces/meta.interface';

const applyRecord: EventMeta = {
    title: 'Apply Record',
    default: {
        description: 'Apply Record',
        longDescription: 'An item is labeled as a record.',
        severity: 'info',
    },
};

export default applyRecord;
